<template>
  <section id="contact-us">
    <div class="full-width-header">Contact Us</div>
    <div class="content d-flex flex-column flex-md-row ga-16 pb-16">
      <div class="fill-width text-center contact-option">
        <a href="https://api.whatsapp.com/send?phone=353833643299" class="text-decoration-none link text-h6 d-flex flex-column align-center">
          <v-icon icon="$mdi-whatsapp" size="100px" class="contact-icon"></v-icon>
          <span class="contact-text">Click here to contact us on WhatsApp!</span>
        </a>
      </div>
      <div class="fill-width text-center contact-option">
        <a href="tel:+353833653299" class="text-decoration-none link text-h6 d-flex flex-column align-center">
          <v-icon icon="$mdi-phone" size="100px" class="contact-icon"></v-icon>
          <span class="contact-text">Click here to give us a call!</span>
        </a>
      </div>
    </div>
  </section>
  <v-footer class="footer py-16">
    <div class="footer-wrapper d-flex flex-column">
      <div class="content d-flex flex-column flex-md-row align-center justify-space-between">
        <div class="footer-column d-flex flex-column align-center pa-4">
          <div class="logo-container">
            <img src="/img/logo%20horizontal.webp" class="logo" alt="Jasmine Puozzo Wellness Centre" />
          </div>
          
          <div class="address-container mt-8">
            <div class="d-flex align-center mb-4">
              <v-icon icon="$mdi-map-marker" color="primary" class="mr-2"></v-icon>
              <p class="text-body-1">
                31 North Main Street, Naas, Co. Kildare
                <br>
                W91 FK3T
              </p>
            </div>
            
            <div class="d-flex align-center">
              <v-icon icon="$mdi-phone" color="primary" class="mr-2"></v-icon>
              <a href="tel:+353833643299" class="text-body-1 contact-link">
                +353 (83) 364-3299
              </a>
            </div>
          </div>
          
          <div class="social-links mt-6">
            <v-btn icon="$mdi-facebook" variant="text" size="large" color="primary" class="social-btn" href="https://www.facebook.com/profile.php?id=100085102736371" target="_blank" aria-label="Facebook"></v-btn>
            <v-btn icon="$mdi-instagram" variant="text" size="large" color="primary" class="social-btn" href="https://instagram.com/jpuozzo_wellnescentre" target="_blank" aria-label="Instagram"></v-btn>
            <v-btn icon="$mdi-whatsapp" variant="text" size="large" color="primary" class="social-btn" href="https://api.whatsapp.com/send?phone=353833643299" target="_blank" aria-label="WhatsApp"></v-btn>
          </div>
        </div>
        
        <div class="footer-column d-flex flex-column align-center pa-4">
          <h3 class="text-h6 mb-4">Our Location</h3>

          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4777.924000880401!2d-6.665508422397626!3d53.218529684278174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48677b049db5ab13%3A0xed413d2b80add125!2sJasmine%20Puozzo%20Wellness%20Centre!5e0!3m2!1sen!2sie!4v1769125480691!5m2!1sen!2sie"
            title="Jasmine Puozzo Wellness Centre location on Google Maps"
            width="500"
            height="215"
            style="border:0;"
            :allowfullscreen="true"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
          <!-- <a href="https://maps.app.goo.gl/MPiMDDZaN4GdJw7N7" target="_blank" class="map-link">
            <div class="map-container">
              <img src="/img/map.webp" class="map" alt="Map location" />
              <div class="map-overlay d-flex align-center justify-center">
                <v-btn color="primary" prepend-icon="$mdi-directions" class="get-directions-btn">
                  Get Directions
                </v-btn>
              </div>
            </div>
          </a> -->
        </div>
      </div>
      
      <div class="content mt-6">
        <v-divider class="mb-6"></v-divider>
        <div class="d-flex flex-column flex-md-row justify-space-between align-center pb-4">
          <div class="copyright text-body-2 text-center text-md-left mb-4 mb-md-0">
            © {{ new Date().getFullYear() }} Jasmine Puozzo Wellness Centre. All rights reserved.
          </div>
          <div class="footer-nav">
            <!-- <a href="/privacy-policy" class="footer-link px-2 py-1">Privacy Policy</a>
            <a href="/terms" class="footer-link px-2 py-1">Terms & Conditions</a> -->
            <button type="button" class="footer-link footer-button px-2 py-1" @click="openCookiePreferences">
              Cookie preferences
            </button>
            <a href="/privacy" class="footer-link px-2 py-1">Privacy</a>
            <a href="/#contact-us" class="footer-link px-2 py-1">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  </v-footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import * as CookieConsent from 'vanilla-cookieconsent';

export default defineComponent({
  name: 'FooterView',
  methods: {
    openCookiePreferences(): void {
      CookieConsent.showPreferences();
    },
  },
});
</script>

<style scoped>
#contact-us {
  scroll-margin-top: 50px;
}

.footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: color-mix(in srgb, rgb(var(--v-theme-background)) 88%, black 12%);
}

.footer-wrapper {
  width: 100%;
  max-width: 1280px;
  padding: 0;
}

.content {
  width: 100%;
  padding: 0 24px;
}

.footer-column {
  width: 100%;
}

.logo-container {
  display: flex;
  justify-content: center;
}

.footer-column .logo {
  width: 90%;
  max-width: 350px;
  transition: opacity 0.3s ease;
}

.footer-column .logo:hover {
  opacity: 0.9;
}

.address-container {
  max-width: 350px;
}

.contact-link {
  text-decoration: none;
  color: #3d3020;
  position: relative;
  transition: color 0.2s ease;
}

.contact-link:hover {
  color: rgb(var(--v-theme-primary));
}

.contact-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 1px;
  bottom: -2px;
  left: 0;
  background-color: rgb(var(--v-theme-primary));
  transition: width 0.3s ease;
}

.contact-link:hover::after {
  width: 100%;
}

.social-links {
  display: flex;
  gap: 16px;
}

.social-btn {
  transition: background-color 0.3s ease;
}

.social-btn:hover {
  background-color: rgba(var(--v-theme-primary), 0.1) !important;
}

.map-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease;
}

.map-container:hover {
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.3);
}

.map {
  width: 100%;
  display: block;
  transition: all 0.5s ease;
}

.map-link {
  text-decoration: none;
  color: #3d3020;
}

.map-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.map-container:hover .map-overlay {
  opacity: 1;
}

.map-container:hover .map {
  transform: scale(1.05);
}

.get-directions-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.footer-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-link {
  color: rgba(61, 48, 32, 0.7);
  text-decoration: none;
  transition: color 0.2s ease;
  position: relative;
}

.footer-link:hover {
  color: rgb(var(--v-theme-primary));
}

.footer-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 1px;
  bottom: -2px;
  left: 0;
  background-color: rgb(var(--v-theme-primary));
  transition: width 0.3s ease;
}

.footer-link:hover::after {
  width: 100%;
}

.footer-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
}

.copyright {
  color: rgba(61, 48, 32, 0.7);
}

@media (max-width: 960px) {
  .footer-column {
    margin-bottom: 40px;
  }
  
  .map-container {
    max-width: 400px;
  }
  
  .footer-nav {
    gap: 8px;
  }
}

@media (max-width: 600px) {
  .content {
    padding: 0 16px;
  }
  
  .footer {
    padding-bottom: 80px !important;
  }
}
</style>